import delhi from '../../assets/tourpackage/1.png';
import jaipur from '../../assets/tourpackage/2.png';
import udaipur from '../../assets/tourpackage/3.png';
import Agra from '../../assets/tourpackage/8.png';
import manali from '../../assets/tourpackage/9.png';
import mumbai from '../../assets/tourpackage/mumbai.png'
import kasmir from '../../assets/tourpackage/Kashmir.jpeg'


const TourPackageData = [
  {
    id: 0,
    title: "Udaipur",
    image: udaipur,
    desc: "Discover the Romantic City of Lakes",
    include: [
      "Hotel Stay – Stay in a heritage hotel or lake-facing property.",
      "Private AC Car – Well-maintained car with an expert driver.",
      "Sightseeing Tour – City Palace, Lake Pichola Boat Ride, Jag Mandir, Fateh Sagar Lake & more.",
      "Professional Tour Guide – Explore the regal charm of Udaipur.",
      "Airport/Railway Station Pickup & Drop – Hassle-free transfers.",
      "Cultural Experience – Enjoy a traditional folk dance show at Bagore Ki Haveli.",
      "Photography Stops – Capture stunning sunset views at Sajjangarh Palace."
    ]
  },
  {
    id: 1,
    title: "Jammu & Kashmir",
    image: kasmir,
    desc: "Experience paradise on earth with mesmerizing valleys, lakes & mountains.",
    include: [
      " Hotel Stay – Choose from Srinagar houseboats, resorts, or budget hotels.",
      "Private AC Car – Travel in a comfortable SUV or tempo traveler.",
      "Sightseeing Tour – Dal Lake, Mughal Gardens, Gulmarg Gondola & Sonmarg.",
      "Tour Guide – Explore the beauty of Kashmir with expert guides.",
      "Pickup & Drop – Hassle-free Airport/Railway Station transfers.",
      "Shikara Ride – Relax with a traditional boat ride on Dal Lake.",
      "Local Cuisine Experience – Taste authentic Kashmiri dishes like Rogan Josh & Kahwa."
    ]
  },
  {
    id: 2,
    title: "Manali",
    image: manali,
    desc: "Escape to the breathtaking mountains of Himachal Pradesh for adventure & relaxation.",
    include: [
      " Hotel Stay – Choose from mountain-view resorts, cottages, or budget hotels.",
      "Private AC Car – Comfortable transport for hill station travel.",
      "Sightseeing Tour – Solang Valley, Rohtang Pass, Hadimba Temple & Mall Road.",
      "Tour Guide – Expert guidance for adventure and sightseeing.",
      "Pickup & Drop – Easy Airport/Railway Station transfers.",
      "Adventure Activities – Enjoy paragliding, river rafting & skiing (seasonal).",
      "Café & Shopping Tour – Visit Old Manali’s famous cafes & local markets.",
      "Hot Springs Visit – Relax at Vashisht Hot Springs."
    ]
  },
  {
    id: 3,
    title: "Jaipur",
    image: jaipur,
    desc: "Explore the Royal Heritage of the Pink City.",
    include: [
      " Hotel Stay – 3-star, 4-star, or  accommodations (as per choice)",
      "Private AC Car – Well-maintained, fully air-conditioned vehicle",
      "Sightseeing Tour – Visit Amber Fort, Hawa Mahal, City Palace & more.",
      "Tour Guide – Experienced guide to explain the rich history & culture",
      "Pickup & Drop – Airport/Railway Station pickup & drop service.",
      "Local Shopping Tour – Explore Jaipur's bazaars for crafts & jewelry.",
    ]
  },
  {
    id: 4,
    title: "Mumbai",
    image: mumbai,
    desc: "Uncover the Vibrant Spirit of the City of Dreams",
    include: [
      "Stay in Premium Hotels – Choose from seaside hotels or city-center stays.",
      " Private AC Car – Comfortable travel within Mumbai.",
      " Guided Sightseeing Tour – Gateway of India, Marine Drive, Elephanta Caves, Juhu Beach, Siddhivinayak Temple & more.",
      " Experienced Tour Guide – Know Mumbai’s rich history & Bollywood tales.",
      " Pickup & Drop – Airport/Railway Station transfers included.",
      " Bollywood Studio Tour (Optional) – Visit film sets & experience the industry magic.",
      " Mumbai Local Food Tour – Taste Vada Pav, Pav Bhaji, and famous street chaats.",

    ]
  },
  {
    id: 5,
    title: "Agra",
    image: Agra,
    desc: "Witness the Timeless Beauty of the Taj Mahal.",
    include: [
      "Comfortable Hotel Stay – Choose from budget to  hotels.",
      " Fully AC Private Car – Travel in comfort with a reliable chauffeur.",
      " Guided Sightseeing Tour – Taj Mahal, Agra Fort, Mehtab Bagh, Itmad-ud-Daulah (Baby Taj).",
      " Professional Tour Guide – Learn fascinating stories about Mughal history.",
      " Pickup & Drop – Airport/Railway Station transfers included.",
      " Local Food Experience – Taste Agra’s famous Petha & Mughlai cuisine.",
      " Fatehpur Sikri Visit (Optional) – Explore the grandeur of the abandoned Mughal city.",
    ]
  },
  {
    id: 6,
    title: "Delhi",
    image: delhi,
    desc: "Experience the Perfect Blend of Heritage & Modernity.",
    include: [
      "Hotel Stay – Comfortable stay in prime locations.",
      "Private AC Car – Travel hassle-free across the city.",
      "City Sightseeing – India Gate, Qutub Minar, Red Fort, Lotus Temple, Humayun’s Tomb & more.",
      "Tour Guide – Discover the history behind Delhi’s architectural wonders.",
      "Pickup & Drop – Airport/Railway station transfers included.",
      "Food Tour – Explore Chandni Chowk’s famous street food (Parathas, Kebabs, Sweets).",
      "Shopping Tour (Optional) – Visit Sarojini Nagar, Connaught Place, & Dilli Haat for unique finds."
    ]
  },

]
export default TourPackageData